import Vue from '../externals/vue'; // Hack to work-around bundling issue
import VueMoment from 'vue-moment'; // eslint-disable-line
import moment from 'moment';

// Load correct locale
require('moment/locale/en-au');

//Update calendar format
moment.updateLocale('en-au', {
  calendar: {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    lastWeek: 'dddd',
    nextWeek: '[Next] dddd',
    sameElse: 'DD/MM/YY hh:mm a',
  },
});

Vue.use(require('vue-moment'), {
  moment,
});

/**
 * The global filter to output standard `countdown` format for Odds.com.au
 */
Vue.filter('countdown', filterCountdown);
Vue.filter('sportsCalendar', sportsCalendar);

/**
 * Uses calendar style formatting for sport event/meeting dates
 * @param date
 * @returns {string}
 */
function sportsCalendar(date) {
  return moment(date).calendar(null, {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    lastWeek: 'dddd',
    nextWeek: '[Next] dddd',
    sameElse: 'ddd MMM DD',
  });
}

/**
 * Callback function of filter `countdown`.
 * Taking care of unix and ISO8601 format conditions.
 *
 * @param {number} timeStamp: starting time of the game
 */
function filterCountdown(timeStamp) {
  const typeOfTimeStamp = typeof timeStamp;
  const currentTimeLocal = Date.now();

  // Purpose of if/else condition:
  // Currently there are 2 types of timeStamp value from API (`2018-03-11 09:55:00` and `1517188775217`)
  // this can provide the logic to take care both cases, and output correct time format as required
  if (typeOfTimeStamp === 'string') {
    // Local moment
    const eventStartTimeLocal = moment(timeStamp);

    // calculating the difference between now and the event starting time (in secs)
    const remainingTime = eventStartTimeLocal.diff(currentTimeLocal) / 1000;
    // return time format
    return fnOutputTimeFormat(remainingTime, eventStartTimeLocal, false);
  } else if (typeOfTimeStamp === 'number') {
    // The condition of timeStamp in this type is `1517188775217`
    // calculating the difference between now and the event starting time (in secs)
    const remainingTime = Math.floor(timeStamp - currentTimeLocal / 1000);
    // return time format
    return fnOutputTimeFormat(remainingTime, timeStamp, true);
  }
}

/**
 * This function deals with the logic that returns correct time format
 * Typical countdown format would like below examples:
 * 58s | 26m 35s | 14h 32m | 4d 16h | 2w 6d
 *
 * @param {number} remainingTime: Difference between now and game starting time.
 * @param {number} eventStartsAt: Game starting time.
 * @param {boolean} isNumber: If true, it means type of value is Number
 */
function fnOutputTimeFormat(remainingTime, eventStartsAt, isNumber = false) {
  if (remainingTime <= 0) {
    // Game has already started
    // show how long ago it was
    if (isNumber === true) {
      return 'ENDED';
    } else {
      // This would return string like `a few seconds ago`
      return moment(eventStartsAt).fromNow();
    }
  } else if (remainingTime < 60) {
    // less than 60s
    // time format examples in this condition: 58s
    const sec = Math.floor(remainingTime);
    return sec + 's';
  } else if (remainingTime < 3600) {
    // less than 1hr
    // time format examples in this condition: 26m 35s
    const min = Math.floor(moment.unix(remainingTime).format('m'));
    const sec = Math.floor(remainingTime - min * 60);
    return min + 'm' + ' ' + sec + 's';
  } else if (remainingTime < 3600 * 24) {
    // less than 1 day
    // time format examples in this condition: 14h 32m
    const hour = Math.floor(remainingTime / 3600);
    const min = Math.floor((remainingTime - hour * 3600) / 60);
    return hour + 'h' + ' ' + min + 'm';
  } else if (remainingTime < 3600 * 24 * 7) {
    // less than 1 week
    // time format examples in this condition: 4d 16h
    const day = Math.floor(remainingTime / (3600 * 24));
    const hour = Math.floor((remainingTime - day * 3600 * 24) / (60 * 60));
    return day + 'd' + ' ' + hour + 'h';
  } else if (remainingTime > 3600 * 24 * 7) {
    // large than 1 week
    // time format examples in this condition: 2w 6d
    const week = Math.floor(remainingTime / (3600 * 24 * 7));
    const day = Math.floor((remainingTime - week * 3600 * 24 * 7) / (60 * 60 * 24));
    return week + 'w' + ' ' + day + 'd';
  }
}
